import { giphyDarkGrey } from '@giphy/js-brand'
import { CSSProperties, forwardRef, isValidElement, ReactNode, ForwardedRef, SyntheticEvent } from 'react'
import ControlSize from '../../../types/control-size'
import Gradient from '../../../types/gradient'
import { Button as ButtonComponent, Icon, Label } from './style'

export type ButtonProps = {
    children?: ReactNode
    className?: string
    color?: string
    disabled?: boolean
    gradient?: Gradient
    icon?: ReactNode
    iconLocation?: 'left' | 'right'
    role?: string
    roleDescription?: string
    size?: ControlSize
    style?: CSSProperties
    tabIndex?: number
    textColor?: string
    title?: string
    onClick?: (e: SyntheticEvent<HTMLButtonElement, Event>) => void
}

const Button = (
    {
        children,
        color = giphyDarkGrey,
        gradient,
        icon,
        iconLocation = 'right',
        size = 'small',
        textColor,
        ...rest
    }: ButtonProps,
    ref: ForwardedRef<any>
) => (
    <ButtonComponent
        {...rest}
        controlColor={color}
        controlSize={size}
        gradient={gradient}
        ref={ref}
        textColor={textColor}
    >
        {icon && iconLocation === 'left' && <Icon>{icon}</Icon>}
        {children && (isValidElement(children) ? children : <Label>{children}</Label>)}
        {icon && iconLocation === 'right' && <Icon>{icon}</Icon>}
    </ButtonComponent>
)

export default forwardRef(Button)
